'use strict'

// inspired by
// https://developpaper.com/question/how-to-access-vue-global-variables-in-vue-files/

/* eslint-disable */
import Vue from 'vue'

let globals = {
    data() {
        return {
            var1: 1,
            var2: 'string'
        }
    },
    methods:{
        myGlobalMethod() { console.log(`myGlobalMethod HOWDY!!`) }
    },
}

// export default globals
export default {
    globals: globals
}

// register global mixin
Vue.mixin(globals);


// WEBPACK FOOTER //
// ./src/plugins/globals.js